<template>

  <div class="footer">
    <p>{{info.Title}} <span></span> <a href="https://beian.miit.gov.cn">粤ICP备18047577号</a></p>
  </div>

</template>

<script>

  export default {
    data () {
      return {
        info:''
      }
    },
    components: {

    },
    methods: {},
    created:function(){
      var that = this
      $.post('http://www.gzmeize.com/ziyu.php?Action=siteweb&setaction=copyright', function(msg) {
        that.info = JSON.parse(msg)
      })
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
    @import "../reset"
    @import "footer"
</style>



// WEBPACK FOOTER //
// src/components/component/footer.vue